module.exports = __webpack_public_path__ + "img/icon-l-active.697d42c3.svg";